import { TenantUserField } from '@/@vxapp/@Enums/PHP/App/Users/Tenant/Enums/TenantUserField'
import { TenantRoleField } from '@/@vxapp/@Enums/PHP/App/Users/Tenant/Roles/Enums/TenantRoleField'
import { TenantRolePermissionField } from '@/@vxapp/@Enums/PHP/App/Users/Tenant/RolePermissions/Enums/TenantRolePermissionField'
import { TenantPermissionDefinitionField } from '@/@vxapp/@Enums/PHP/App/Users/Tenant/PermissionDefinitions/Enums/TenantPermissionDefinitionField'
import { Endpoint } from '@/@vxapp/@Enums/Endpoint'
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import { AuthErrors } from '@/@vxapp/Auth/AuthErrors'
import { AssetsTableActions } from '@/@vxapp/Assets/AssetsActions'
import { AssetsTableHeaders } from '@/@vxapp/Assets/AssetsTableHeaders'
import { BookingOptionSelectionsTableActions } from '@/@vxapp/Products/BookingOptions/Selections/BookingOptionSelectionsActions'
import { BookingOptionSelectionsTableHeaders } from '@/@vxapp/Products/BookingOptions/Selections/BookingOptionSelectionsTableHeaders'
import { BookingOptionsTableActions } from '@/@vxapp/Products/BookingOptions/BookingOptionsActions'
import { BookingOptionsTableHeaders } from '@/@vxapp/Products/BookingOptions/BookingOptionsTableHeaders'
import { ContractsTableActions } from '@/@vxapp/Contracts/ContractsActions'
import { ContractsTableHeaders } from '@/@vxapp/Contracts/ContractsTableHeaders'
import { BusinessesTableActions } from '@/@vxapp/Businesses/BusinessesActions'
import { BusinessesTableHeaders } from '@/@vxapp/Businesses/BusinessesTableHeaders'
import { CalendarErrors } from '@/@vxapp/Calendar/CalendarErrors'
import { CronErrors } from '@/@vxapp/Cron/CronErrors'
import { CustomersTableActions } from '@/@vxapp/Customers/CustomersActions'
import { CustomersTableHeaders } from '@/@vxapp/Customers/CustomersTableHeaders'
import { InvoicesTableActions } from '@/@vxapp/Invoices/InvoicesActions'
import { InvoicesErrors } from '@/@vxapp/Invoices/InvoicesErrors'
import { InvoicesTableHeaders } from '@/@vxapp/Invoices/InvoicesTableHeaders'
import { JobsTableActions } from '@/@vxapp/Jobs/JobsActions'
import { JobsTableHeaders } from '@/@vxapp/Jobs/JobsTableHeaders'
import { MessagesTableActions } from '@/@vxapp/Messages/MessagesActions'
import { MessagesErrors } from '@/@vxapp/Messages/MessagesErrors'
import { MessagesIcons } from '@/@vxapp/Messages/MessagesIcons'
import { MessagesLocale } from '@/@vxapp/Messages/MessagesLocale'
import { MessagesTableHeaders } from '@/@vxapp/Messages/MessagesTableHeaders'
import { MicrosoftOAuthErrors } from '@/@vxapp/MicrosoftOAuth/MicrosoftOAuthErrors'
import { OrdersTableActions } from '@/@vxapp/Orders/OrdersActions'
import { OrdersTableHeaders } from '@/@vxapp/Orders/OrdersTableHeaders'
import { ProductCategoriesTableActions } from '@/@vxapp/ProductCategories/ProductCategoriesActions'
import { ProductCategoriesTableHeaders } from '@/@vxapp/ProductCategories/ProductCategoriesTableHeaders'
import { ProductsTableActions } from '@/@vxapp/Products/ProductsActions'
import { ProductsTableHeaders } from '@/@vxapp/Products/ProductsTableHeaders'
import { QuotesTableActions } from '@/@vxapp/Quotes/QuotesActions'
import { QuotesTableHeaders } from '@/@vxapp/Quotes/QuotesTableHeaders'
import { SitesTableActions } from '@/@vxapp/Sites/SitesActions'
import { SitesTableHeaders } from '@/@vxapp/Sites/SitesTableHeaders'
import { InstagramAccountsErrors } from '@/@vxapp/InstagramAccounts/InstagramAccountsErrors'
import { MetaOAuthErrors } from '@/@vxapp/MetaOAuth/MetaOAuthErrors'
import { HoardingsLocale } from '@/@vxapp/Hoardings/HoardingsLocale'
import { BusinessField } from '@/@vxapp/@Enums/PHP/ServicesV2/Businesses/DataProviders/BusinessField'
import { InvoiceField } from '@/@vxapp/@Enums/PHP/ServicesV2/Invoices/DataProviders/InvoiceField'
import { JobField } from '@/@vxapp/Jobs/JobFieldStub'
import { MessageField } from '@/@vxapp/@Enums/PHP/ServicesV2/Messages/DataProviders/MessageField'
import { OrderField } from '@/@vxapp/@Enums/PHP/ServicesV2/Orders/DataProviders/OrderField'
import { ProductCategoryField } from '@/@vxapp/@Enums/PHP/ServicesV2/Products/Categories/DataProviders/ProductCategoryField'
import { ProductField } from '@/@vxapp/@Enums/PHP/ServicesV2/Products/DataProviders/ProductField'
import { QuoteField } from '@/@vxapp/@Enums/PHP/ServicesV2/Quotes/DataProviders/QuoteField'
import { SiteField } from '@/@vxapp/@Enums/PHP/ServicesV2/Sites/Enums/SiteField'
import type { ServiceKey } from '@/@vxapp/@Types/ServiceMetadata'
import { defineServiceSpec } from './defineServiceSpec'

export const ServiceSpecs = {
  TenantPermissionDefinitions: defineServiceSpec({
    key: 'TenantPermissionDefinitions',
    name: 'TenantPermissionDefinitions',
    endpoint: Endpoint.TenantPermissionDefinitions,
    page: PageMeta.TenantPermissionDefinitions,
    databaseIdentifier: TenantPermissionDefinitionField.DB_IDENTIFIER,
  }),

  TenantRolePermissions: defineServiceSpec({
    key: 'TenantRolePermissions',
    name: 'TenantRolePermissions',
    endpoint: Endpoint.TenantRolePermissions,
    page: PageMeta.TenantRolePermissions,
    databaseIdentifier: TenantRolePermissionField.DB_IDENTIFIER,
  }),

  TenantRoles: defineServiceSpec({
    key: 'TenantRoles',
    name: 'TenantRoles',
    endpoint: Endpoint.TenantRoles,
    page: PageMeta.TenantRoles,
    databaseIdentifier: TenantRoleField.DB_IDENTIFIER,
  }),

  TenantUsers: defineServiceSpec({
    key: 'TenantUsers',
    name: 'TenantUsers',
    endpoint: Endpoint.TenantUsers,
    page: PageMeta.TenantUsers,
    databaseIdentifier: TenantUserField.DB_IDENTIFIER,
  }),

  Auth: defineServiceSpec({
    key: 'Auth',
    name: 'Auth',
    endpoint: Endpoint.Auth,
    page: PageMeta.Auth,
    errors: AuthErrors,
  }),
  Assets: defineServiceSpec({
    key: 'Assets',
    name: 'Assets',
    endpoint: Endpoint.Assets,
    page: PageMeta.Assets,
    databaseIdentifier: 'assetGUID',
    table: { headers: AssetsTableHeaders, actions: AssetsTableActions },
  }),
  BookingOptionSelections: defineServiceSpec({
    key: 'BookingOptionSelections',
    name: 'BookingOptionSelections',
    endpoint: Endpoint.BookingOptionSelections,
    page: PageMeta.Selections,
    databaseIdentifier: 'selectionGUID',
    table: {
      headers: BookingOptionSelectionsTableHeaders,
      actions: BookingOptionSelectionsTableActions,
    },
  }),
  BookingOptions: defineServiceSpec({
    key: 'BookingOptions',
    name: 'BookingOptions',
    endpoint: Endpoint.BookingOptions,
    page: PageMeta.BookingOptions,
    databaseIdentifier: 'optionGUID',
    table: {
      headers: BookingOptionsTableHeaders,
      actions: BookingOptionsTableActions,
    },
  }),
  Contracts: defineServiceSpec({
    key: 'Contracts',
    name: 'Contracts',
    endpoint: Endpoint.Contracts,
    databaseIdentifier: 'contractGUID',
    table: {
      headers: ContractsTableHeaders,
      actions: ContractsTableActions,
    },
  }),
  Businesses: defineServiceSpec({
    key: 'Businesses',
    name: 'Businesses',
    endpoint: Endpoint.Businesses,
    page: PageMeta.Businesses,
    databaseIdentifier: BusinessField.DB_IDENTIFIER,
    table: {
      headers: BusinessesTableHeaders,
      actions: BusinessesTableActions,
    },
  }),
  Calendar: defineServiceSpec({
    key: 'Calendar',
    name: 'Calendar',
    endpoint: Endpoint.Calendar,
    page: PageMeta.Calendar,
    errors: CalendarErrors,
  }),
  Cron: defineServiceSpec({
    key: 'Cron',
    name: 'Cron',
    endpoint: Endpoint.Cron,
    errors: CronErrors,
  }),
  Customers: defineServiceSpec({
    key: 'Customers',
    name: 'Customers',
    endpoint: Endpoint.Customers,
    page: PageMeta.Customers,
    databaseIdentifier: 'clientGUID',
    table: {
      headers: CustomersTableHeaders,
      actions: CustomersTableActions,
    },
  }),
  Hoardings: defineServiceSpec({
    key: 'Hoardings',
    name: 'Hoardings',
    page: PageMeta.Tools,
    locale: HoardingsLocale,
  }),
  MetaOAuth: defineServiceSpec({
    key: 'MetaOAuth',
    name: 'Meta OAuth',
    endpoint: Endpoint.MetaOAuth,
    errors: MetaOAuthErrors,
  }),
  MetaCompliance: defineServiceSpec({
    key: 'MetaCompliance',
    name: 'Meta Compliance',
    endpoint: Endpoint.MetaCompliance,
  }),
  InstagramAccounts: defineServiceSpec({
    key: 'InstagramAccounts',
    name: 'Instagram Accounts',
    endpoint: Endpoint.InstagramAccounts,
    errors: InstagramAccountsErrors,
  }),
  Invoices: defineServiceSpec({
    key: 'Invoices',
    name: 'Invoices',
    endpoint: Endpoint.Invoices,
    page: PageMeta.Invoices,
    databaseIdentifier: InvoiceField.DB_IDENTIFIER,
    statusField: InvoiceField.STATUS,
    errors: InvoicesErrors,
    table: {
      headers: InvoicesTableHeaders,
      actions: InvoicesTableActions,
    },
  }),
  Jobs: defineServiceSpec({
    key: 'Jobs',
    name: 'Jobs',
    endpoint: Endpoint.Jobs,
    page: PageMeta.Projects,
    databaseIdentifier: JobField.DB_IDENTIFIER,
    statusField: JobField.STATUS,
    table: {
      headers: JobsTableHeaders,
      actions: JobsTableActions,
    },
  }),
  Messages: defineServiceSpec({
    key: 'Messages',
    name: 'Messages',
    endpoint: Endpoint.Messages,
    page: PageMeta.Messages,
    databaseIdentifier: MessageField.DB_IDENTIFIER,
    statusField: MessageField.STATUS,
    errors: MessagesErrors,
    icons: MessagesIcons,
    locale: MessagesLocale,
    table: {
      headers: MessagesTableHeaders,
      actions: MessagesTableActions,
    },
  }),
  MicrosoftOAuth: defineServiceSpec({
    key: 'MicrosoftOAuth',
    name: 'MicrosoftOAuth',
    endpoint: Endpoint.MicrosoftOAuth,
    page: PageMeta.MicrosoftOAuth,
    errors: MicrosoftOAuthErrors,
  }),
  Orders: defineServiceSpec({
    key: 'Orders',
    name: 'Orders',
    endpoint: Endpoint.Orders,
    page: PageMeta.Orders,
    databaseIdentifier: OrderField.DB_IDENTIFIER,
    statusField: OrderField.STATUS,
    table: {
      headers: OrdersTableHeaders,
      actions: OrdersTableActions,
    },
  }),
  ProductCategories: defineServiceSpec({
    key: 'ProductCategories',
    name: 'ProductCategories',
    endpoint: Endpoint.ProductCategories,
    page: PageMeta.Categories,
    databaseIdentifier: ProductCategoryField.DB_IDENTIFIER,
    table: {
      headers: ProductCategoriesTableHeaders,
      actions: ProductCategoriesTableActions,
    },
  }),
  Products: defineServiceSpec({
    key: 'Products',
    name: 'Products',
    endpoint: Endpoint.Products,
    page: PageMeta.Products,
    databaseIdentifier: ProductField.DB_IDENTIFIER,
    table: {
      headers: ProductsTableHeaders,
      actions: ProductsTableActions,
    },
  }),
  Quotes: defineServiceSpec({
    key: 'Quotes',
    name: 'Quotes',
    endpoint: Endpoint.Quotes,
    page: PageMeta.Quotes,
    databaseIdentifier: QuoteField.DB_IDENTIFIER,
    statusField: QuoteField.STATUS,
    table: {
      headers: QuotesTableHeaders,
      actions: QuotesTableActions,
    },
  }),
  Sites: defineServiceSpec({
    key: 'Sites',
    name: 'Sites',
    endpoint: Endpoint.Sites,
    page: PageMeta.Sites,
    databaseIdentifier: SiteField.DB_IDENTIFIER,
    statusField: SiteField.STATUS,
    table: {
      headers: SitesTableHeaders,
      actions: SitesTableActions,
    },
  }),
} as const satisfies Record<ServiceKey, unknown>

export type ServiceSpecKey = keyof typeof ServiceSpecs

export const DataTableHeaders = {
  Assets: ServiceSpecs.Assets.table!.headers!,
  BookingOptionSelections: ServiceSpecs.BookingOptionSelections.table!.headers!,
  BookingOptions: ServiceSpecs.BookingOptions.table!.headers!,
  Contracts: ServiceSpecs.Contracts.table!.headers!,
  Customers: ServiceSpecs.Customers.table!.headers!,
  Businesses: ServiceSpecs.Businesses.table.headers,
  Invoices: ServiceSpecs.Invoices.table.headers,
  Jobs: ServiceSpecs.Jobs.table!.headers!,
  Messages: ServiceSpecs.Messages.table.headers,
  Orders: ServiceSpecs.Orders.table.headers,
  ProductCategories: ServiceSpecs.ProductCategories.table.headers,
  Products: ServiceSpecs.Products.table.headers,
  Quotes: ServiceSpecs.Quotes.table.headers,
  Sites: ServiceSpecs.Sites.table.headers,
} as const

export const DataTableActions = {
  Assets: ServiceSpecs.Assets.table!.actions!,
  BookingOptionSelections: ServiceSpecs.BookingOptionSelections.table!.actions!,
  BookingOptions: ServiceSpecs.BookingOptions.table!.actions!,
  Contracts: ServiceSpecs.Contracts.table!.actions!,
  Customers: ServiceSpecs.Customers.table!.actions!,
  Businesses: ServiceSpecs.Businesses.table.actions,
  Invoices: ServiceSpecs.Invoices.table.actions,
  Jobs: ServiceSpecs.Jobs.table!.actions!,
  Messages: ServiceSpecs.Messages.table.actions,
  Orders: ServiceSpecs.Orders.table.actions,
  ProductCategories: ServiceSpecs.ProductCategories.table.actions,
  Products: ServiceSpecs.Products.table.actions,
  Quotes: ServiceSpecs.Quotes.table.actions,
  Sites: ServiceSpecs.Sites.table.actions,
} as const

export const ErrorSpecs = {
  Auth: ServiceSpecs.Auth.errors,
  Calendar: ServiceSpecs.Calendar.errors,
  Cron: ServiceSpecs.Cron.errors,
  InstagramAccounts: ServiceSpecs.InstagramAccounts.errors,
  Invoices: ServiceSpecs.Invoices.errors,
  Messages: ServiceSpecs.Messages.errors,
  MetaOAuth: ServiceSpecs.MetaOAuth.errors,
  MicrosoftOAuth: ServiceSpecs.MicrosoftOAuth.errors,
} as const

export const IconSpecs = {
  Messages: ServiceSpecs.Messages.icons,
} as const

export const LocaleSpecs = {
  Hoardings: ServiceSpecs.Hoardings.locale,
  Messages: ServiceSpecs.Messages.locale,
} as const
